// Hinweis für mich: Size wird nicht wirklich geupdatet! Watcher ist leer!
<template>
  <div style="display: none;">
    <slot v-if="ready"></slot>
  </div>
</template>

<script>
import L from 'leaflet'
import VectorIcon from 'leaflet-vectoricon' // eslint-disable-line
import { propsBinder, findRealParent } from 'vue2-leaflet' // eslint-disable-line

const props = {
  draggable: {
    type: Boolean,
    custom: true,
    default: false
  },
  small: {
    type: Boolean,
    custom: false,
    default: false
  },
  visible: {
    type: Boolean,
    custom: true,
    default: true
  },
  size: {
    type: Object,
    custom: true
  },
  className: {
    type: String,
    custom: true,
    default: null
  },
  title: {
    type: String,
    custom: true,
    default: ''
  },
  latLng: {
    type: [Object, Array],
    custom: true
  },
  zIndexOffset: {
    type: Number,
    custom: false
  },
  options: {
    type: Object,
    default: () => ({})
  }
}

export default {
  name: 'LAreaText',
  props: props,
  data () {
    return {
      iconClass: this.className.toLowerCase(),
      ready: false,
      icon: new L.VectorIcon({
        className: 't-' + this.className.toLowerCase(),
        svgHeight: this.size.height,
        svgWidth: 150,
        type: 'text', // path | circle | rect | text
        shape: {
          x: 150 / 2,
          y: this.size.height / 2
        },
        style: {
          fill: '#262834',
          // stroke: '#fff',
          strokeWidth: 2,
          fontFamily: 'Dosis',
          fontSize: '17',
          fontWeight: '700'
        },
        text: this.title
      }),
      iconSmall: new L.VectorIcon({
        className: 't-' + this.className.toLowerCase(),
        svgHeight: this.size.height,
        svgWidth: 150,
        type: 'text', // path | circle | rect | text
        shape: {
          x: 150 / 2,
          y: this.size.height / 2
        },
        style: {
          fill: '#262834',
          // stroke: '#fff',
          strokeWidth: 2,
          fontFamily: 'Dosis',
          fontSize: '12',
          fontWeight: '700'
        },
        text: this.title
      })
    }
  },
  mounted () {
    const options = this.options
    if (this.small === true) {
      options.icon = this.iconSmall
    } else {
      options.icon = this.icon
    }
    options.draggable = this.draggable
    this.mapObject = L.marker(this.latLng, options)
    this.mapObject.on('move', (ev) => {
      if (Array.isArray(this.latLng)) {
        this.latLng[0] = ev.latlng.lat
        this.latLng[1] = ev.latlng.lng
      } else {
        this.latLng.lat = ev.latlng.lat
        this.latLng.lng = ev.latlng.lng
      }
    })
    L.DomEvent.on(this.mapObject, this.$listeners)
    propsBinder(this, this.mapObject, props)
    this.ready = true
    this.parentContainer = findRealParent(this.$parent)
    this.parentContainer.addLayer(this, !this.visible)
  },
  beforeDestroy () {
    this.parentContainer.removeLayer(this)
  },
  methods: {
    setDraggable (newVal, oldVal) {
      if (this.mapObject.dragging) {
        newVal ? this.mapObject.dragging.enable() : this.mapObject.dragging.disable()
      }
    },
    setVisible (newVal, oldVal) {
      if (newVal === oldVal) return
      if (this.mapObject) {
        if (newVal) {
          this.parentContainer.addLayer(this)
        } else {
          this.parentContainer.removeLayer(this)
        }
      }
    },
    setSize (newVal) {

    },
    update () {
      var newIcon = new L.VectorIcon({
        className: 't-' + this.iconClass,
        svgHeight: this.size.height,
        svgWidth: 150,
        type: 'text', // path | circle | rect | text
        shape: {
          x: 150 / 2,
          y: this.size.height / 2
        },
        style: {
          fill: '#334274',
          // stroke: '#fff',
          strokeWidth: 2,
          fontFamily: 'Dosis',
          fontSize: '17',
          fontWeight: '700'
        },
        text: this.title
      })

      document.querySelectorAll('.t-' + this.iconClass + ' svg')[0].remove()
      this.mapObject.setIcon(newIcon)
    },
    setTitle (newVal, oldVal) {
      if (newVal === oldVal) return
      if (newVal) {
        this.update()
      }
    },
    setLatLng (newVal) {
      if (newVal === null) {
        return
      }

      if (this.mapObject) {
        let oldLatLng = this.mapObject.getLatLng()
        let newLatLng = {
          lat: newVal[0] || newVal.lat,
          lng: newVal[1] || newVal.lng
        }
        if (newLatLng.lat !== oldLatLng.lat || newLatLng.lng !== oldLatLng.lng) {
          this.mapObject.setLatLng(newLatLng)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LAreaText.vue